import React from "react";
import { CloseOutlined, Lock } from "@material-ui/icons";
import { useCustomColumnLockedModal } from "../utils/useCustomColumnLockedModal";

export const CustomColumnModalLockedHeader = () => {
  const { closeCustomColumnLockedModal } = useCustomColumnLockedModal();
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-p-4 tw-border-solid tw-border-0 tw-border-b-2 tw-border-[#e7e6e4]">
      <span className="tw-text-[#1c274c] tw-text-lg tw-font-medium tw-leading-normal tw-flex tw-items-center">
        <Lock className="tw-w-[18px] tw-h-[18px] tw-mr-[6px] !tw-fill-[#ffaa00]" />
        Upgrade plan to continue
      </span>
      <CloseOutlined
        className="tw-w-4 tw-h-4 tw-cursor-pointer"
        onClick={closeCustomColumnLockedModal}
      />
    </div>
  );
};
